import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { faPhoneOffice, faSign } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { InsightsListing } from 'bundles/connect/types';
import React from 'react';
import { Card } from 'react-bootstrap-5';
import { USD } from 'helpers/formatters/number_formats';

type Props = {
  listing: InsightsListing;
}

export default function PropertyListing({ listing }: Props) {
  const broker = listing.brokerInfo[0];

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex gap-2 align-items-center">
        <FontAwesomeIcon className="text-secondary" icon={faSign} />
        <h6 className="mb-0">Active Listing</h6>
      </div>
      <Card className="d-flex flex-row justify-content-between listing-info p-4">
        <div>
          {broker.brokerage && (
            <small className="text-muted">{broker.brokerage}</small>
          )}
          <div className="fw-bold">
            {broker.name}
          </div>
          {broker.email && (
            <div className="d-flex gap-1 align-items-center">
              <FontAwesomeIcon className="text-primary" icon={faEnvelope} size="sm" />
              <a href={`mailto:${broker.email}`}>
                {broker.email}
              </a>
            </div>
          )}
          {broker.phone && (
            <div className="d-flex gap-1 align-items-center">
              <FontAwesomeIcon className="text-primary" icon={faPhoneOffice} size="sm" />
              <a href={`tel:${broker.phone}`}>
                {broker.phone}
              </a>
            </div>
          )}
        </div>
        <div>
          <div className="fs-large fw-bolder">
            {USD.format(listing.salePrice, { round: true })}
          </div>
          <div className="text-end fs-x-small text-muted">
            List Price
          </div>
        </div>
      </Card>
    </div>
  );
}
